import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import { Button } from 'react-toolbox/lib/button'
import Input from 'react-toolbox/lib/input'
import { Flex, Box } from 'reflexbox'

import styles from './styles.scss'

class CommentBox extends Component {

  render (){
    const { value, onChange } = this.props
    return (
      <Box px={1} pb={1} className={styles.box}>
        <Input
          theme={styles}
          type='text'
          multiline
          value={value}
          onChange={onChange}
        />
      </Box>
    )
  }
}

export default CSSModules(CommentBox, styles)
